export default __webpack_public_path__ + "static/media/testimony_teacher_five.1b60bf7e.png";